import * as S from './style';
const Rules = () => (
	<S.RuleContainer>
		<S.RuleContent>
			<S.RuleTitle>제 1장 총칙</S.RuleTitle>
			<S.RuleContentItem>
				<S.RuleSubTitle>제 1조 (명칭)</S.RuleSubTitle>
				<S.RuleDescription>본회는 한국노화학회(The Korean Society for Gerontology) 라 칭한다.</S.RuleDescription>
			</S.RuleContentItem>
			<S.RuleContentItem>
				<S.RuleSubTitle>제 2조 (목적)</S.RuleSubTitle>
				<S.RuleDescription>
					본회는 노화현상의 기초 및 응용 연구를 촉진하고 그의 이론과 기술을 보급함으로써 노화 관련 학문 및 산업의 발전에 기여함을 목적으로 한다.
				</S.RuleDescription>
			</S.RuleContentItem>
			<S.RuleContentItem>
				<S.RuleSubTitle>제 3조 (사무소의 소재)</S.RuleSubTitle>
				<S.RuleDescription>본회의 사무소를 둘 수 있으며 필요에 따라 지부를 둘 수 있다.</S.RuleDescription>
			</S.RuleContentItem>
			<S.RuleContentItemBox>
				<S.RuleContentItem>
					<S.RuleSubTitle>제 4조 (사업)</S.RuleSubTitle>
					<S.RuleDescription>본회는 제2조의 목적 달성을 위하여 다음과 같은 사업을 수행한다.</S.RuleDescription>
				</S.RuleContentItem>
				<S.DescriptionBox>
					<li>학술발표회, 강연회, 토론회 개최</li>
					<li>노화연구 관련 각종 간행물의 발행</li>
					<li>학계와 산업계간의 학술교류 및 협동사업</li>
					<li>학술 연구의 장려 및 우수업적 표창</li>
					<li>기타 본회의 목적 달성에 필요한 사항</li>
				</S.DescriptionBox>
			</S.RuleContentItemBox>
		</S.RuleContent>
		<S.RuleContent>
			<S.RuleTitle>제 2장 회원</S.RuleTitle>
			<S.RuleContentItemBox>
				<S.RuleContentItem>
					<S.RuleSubTitle>제 5조 (구성)</S.RuleSubTitle>
					<S.RuleDescription>본회의 회원은 다음과 같이 구성한다.</S.RuleDescription>
				</S.RuleContentItem>
				<S.DescriptionBox>
					<li>정회원</li>
					<li>학생회원</li>
					<li>특별회원</li>
					<li>명예회원</li>
				</S.DescriptionBox>
			</S.RuleContentItemBox>
			<S.RuleContentItemBox>
				<S.RuleContentItem>
					<S.RuleSubTitle>제 6조 (자격)</S.RuleSubTitle>
					<S.RuleDescription>회원은 다음의 자격에 따라 학회가 안내하는 회원가입 및 회비를 납부하여야 한다.</S.RuleDescription>
				</S.RuleContentItem>
				<S.DescriptionBox>
					<li>
						정회원은 박사학위를 소지한 또는 이에 동등한 자격을 갖춘 자로 대학 및 연구기관 선임연구원 이상 또는 이에 준하는 전문 기관 및 기업의 경력 자격이 있는
						자
					</li>
					<li>학생회원은 대학(교), 대학원의 재학생 및 연구소의 석사급 이하 연구원</li>
					<li>특별회원은 본회의 목적과 사업을 위해 학회에 기여도가 높은 자</li>
					<li>명예회원은 본회의 명예 및 위상을 드높이는 자</li>
				</S.DescriptionBox>
			</S.RuleContentItemBox>
			<S.RuleContentItem>
				<S.RuleSubTitle>제 7조 (권리와 의무)</S.RuleSubTitle>
				<S.DescriptionBox>
					<li>회원은 제 6조에 명시한 절차를 거쳐 가입과 동시에 소정의 회비를 납부함으로써 정관에 정한 권리를 갖는다.</li>
					<li>모든 회원은 본회의 각종 행사에 참석할 자격을 가지며, 학회를 통한 다양한 정보, 포상 및 활동의 기회를 제공받는다.</li>
					<li>정회원은 총회의 의결권, 선거권, 피선거권을 갖는다.</li>
					<li>
						모든 회원은 학회의 활동에 참여할 권리를 가지며, 회칙 및 총회의 결정사항을 준수하고, 회비를 납부할 의무를 진다.
						<br />
						단, 연회비를 3년 이상 납부하지 않을 경우 회원 대상 제공 혜택에서 제외된다.
					</li>
				</S.DescriptionBox>
			</S.RuleContentItem>
			<S.RuleContentItem>
				<S.RuleSubTitle>제 8조 (제명과 탈퇴)</S.RuleSubTitle>
				<S.RuleDescription>
					회원이 본회의 의무를 이행하지 않은 경우, 회원 자격을 상실하였을 경우, 그리고 본회에 심각한 손상을 주었을 경우에는 임원회의 의결을 거쳐 제명할 수 있다.
					탈퇴를 원하는 회원의 경우 탈퇴의사를 학회 사무소에 밝힘으로써 7조의 권리와 의무를 포기할 수 있다.
				</S.RuleDescription>
			</S.RuleContentItem>
		</S.RuleContent>
		<S.RuleContent>
			<S.RuleTitle>제 3장 임원</S.RuleTitle>
			<S.RuleContentItemBox>
				<S.RuleContentItem>
					<S.RuleSubTitle>제 9조 (구성)</S.RuleSubTitle>
					<S.RuleDescription>본회는 다음의 임원을 두나 필요에 따라서는 임원회의 의결을 거쳐 임원을 추가하거나 제외하는 것이 가능하다.</S.RuleDescription>
				</S.RuleContentItem>
				<S.DescriptionBox>
					<li>회장 1명</li>
					<li>부회장 3명</li>
					<li>감사 2명</li>
					<li>
						위원회 위원장: 운영위원장, 총무위원장, 학술위원장, 기획위원장, 출판위원장, 홍보위원장, 재무위원장, 국제위원장, 자문위원장, 포상위원장 및 기금위원장
						각 1명
					</li>
				</S.DescriptionBox>
			</S.RuleContentItemBox>
			<S.RuleContentItem>
				<S.RuleSubTitle>제 10조 (선임)</S.RuleSubTitle>
				<S.RuleDescription>
					회장은 전년도 부회장 중 임명된 순서에 따라 선출함을 원칙으로 하나 부득이한 경우 부회장들의 의견 조율을 통해 조정이 가능하다. 그 외 임원은 신임회장이
					전년도 임원회와 논의하여 임원회에서 선출한다.
				</S.RuleDescription>
			</S.RuleContentItem>

			<S.RuleContentItem>
				<S.RuleSubTitle>제 11조 (임기)</S.RuleSubTitle>
				<S.RuleDescription>
					임원의 임기는 1년으로 하며 연임할 수 있다. 단 전임자의 유고로 인해 보선된 임원의 임기는 전임자 임기의 잔임 기간으로 한다.
				</S.RuleDescription>
			</S.RuleContentItem>
			<S.RuleContentItemBox>
				<S.RuleSubTitle>제 12조 (직무)</S.RuleSubTitle>
				<S.DescriptionBox>
					<li>회장은 본회를 대표하여 업무를 총괄하고 총회 및 임원회의 의장이 된다.</li>
					<li>부회장은 회장을 보좌하며 회장 유고시 그 직무를 대행 한다.</li>
					<li>감사는 본회의 재정상황과 사업에 관련된 사항을 감사하고 이를 총회에 보고 한다.</li>
					<li>모든 임원은 회장의 명을 받아 본회의 제반 실무를 처리한다.</li>
				</S.DescriptionBox>
			</S.RuleContentItemBox>
		</S.RuleContent>
		<S.RuleContent>
			<S.RuleTitle>제 4장 회의</S.RuleTitle>
			<S.RuleContentItem>
				<S.RuleSubTitle>제 13조 (구분)</S.RuleSubTitle>
				<S.RuleDescription>본회는 총회, 임원회 및 각종 위원회를 둔다.</S.RuleDescription>
			</S.RuleContentItem>

			<S.RuleContentItemBox>
				<S.RuleSubTitle>제 14조 (총회)</S.RuleSubTitle>
				<S.DescriptionBox>
					<li>
						정기총회는 필요시 학술대회 기간에 개최하고, 임시총회는 회장이나 임원회에서 필요하다고 인정될 때, 그리고 정회원의 1/10 이상의 요구가 있을 때 회장이
						소집한다.
					</li>
					<li>임시총회는 심의안건을 통지서, 본회 홈페이지 혹은 전자우편으로 공고하여 소집한다.</li>
					<li>정기총회는 다음 사항을 심의 의결한다.</li>
					<ol type="a">
						<li>예산 및 결산의 승인</li>
						<li>사업보고 및 계획의 승인</li>
						<li>회칙 개정</li>
						<li>임원회의 부의사항</li>
						<li>정회원에 의해 발의된 사항</li>
						<li>기타 필요사항</li>
					</ol>
				</S.DescriptionBox>
			</S.RuleContentItemBox>
			<S.RuleContentItemBox>
				<S.RuleSubTitle>제 15조 (임원회)</S.RuleSubTitle>
				<S.DescriptionBox>
					<li>
						임원회는 회장, 부회장, 운영위원장, 총무위원장, 학술위원장, 기획위원장, 출판위원장, 홍보위원장, 재무위원장, 국제위원장, 자문위원장 및 기금위원장으로
						구성한다.
					</li>
					<li>임원회는 본회의 운영 및 외부 기관 협력에 필요한 제반 사항을 심의 결정 한다.</li>
				</S.DescriptionBox>
			</S.RuleContentItemBox>
			<S.RuleContentItemBox>
				<S.RuleSubTitle>제 16조 (위원회)</S.RuleSubTitle>
				<S.DescriptionBox>
					<li>각 위원회는 위원장 1인을 포함하여 필요에 따라 10인 이내의 위원으로 구성한다.</li>
					<li>각 위원회의 활동은 다음과 같다</li>
					<ol type="a">
						<li>운영 위원회 : 회장을 보좌하며 학회 운영을 총괄하고, 각 위원회간의 연계에 관한 활동</li>
						<li>총무 위원회 : 재무 관리 및 각종 학술 발표회 및 학회 사업 진행 지원</li>
						<li>학술 위원회 : 학술 발표회에 관한 학술활동 (프로그램 및 연자 구성 포함)</li>
						<li>기획 위원회 : 사업 계획 및 예산편성, 회칙 개정안 심의</li>
						<li>출판 위원회 : 학회 각종 간행물의 발행</li>
						<li>홍보 위원회 : 학회 홈페이지 구축 유지 관리, 홈페이지를 통한 주요사업에 관한 홍보 및 대외 언론 홍보 활동</li>
						<li>재무 위원회 : 학회운영의 건전한 재정유지에 관한 연계활동 및 외부 기금 모금을 위한 제반 활동</li>
						<li>국제 위원회 : 한일공동심포지엄 구성 및 지원, 학술 발표회의 외국 연자 구성 및 관련 제반 활동</li>
						<li>자문 위원회 : 학회제반 활동에 대한 자문</li>
						<li>기금 위원회 : 특별 기금의 관리 및 활용에 대한 심의</li>
						<li>
							포상 위원회: 위원으로 당해연도 회장, 부회장, 운영위원장, 기획위원장을 당연직으로 구성하며 별도의 위원을 둘 수 있다. 정회원을 대상으로 학회의 공로,
							우수한 업적 등을 심의하여 학회의 별도 기준에 따른 대상자를 선정한다.
						</li>
					</ol>
					<li>학회발전을 위해 필요하다고 인정되는 경우 임원회의 의결을 거쳐 추가로 기타 위원회를 둘 수 있다.</li>
				</S.DescriptionBox>
			</S.RuleContentItemBox>
			<S.RuleContentItem>
				<S.RuleSubTitle>제 17조 (의결)</S.RuleSubTitle>
				<S.RuleDescription>
					총회는 정회원 1/10 이상의 출석으로 성립하고, 임원회 및 위원회는 각 임원 및 위원 1/3 이상의 출석으로 성립한다.
					<br />각 회의 의결은 출석 인원의 과반수이상의 찬성으로 한다. 단, 총회 및 임원회에 참석할 수 없는 경우 서면으로 의결권을
					<br /> 위임하면 이를 출석으로 간주한다.
				</S.RuleDescription>
			</S.RuleContentItem>
		</S.RuleContent>
		<S.RuleContent>
			<S.RuleTitle>제 5장 재정</S.RuleTitle>
			<S.RuleContentItem>
				<S.RuleSubTitle>제 18조 (재원)</S.RuleSubTitle>
				<S.RuleDescription>본 회의 재정은 다음의 수입금으로 한다.</S.RuleDescription>
				<S.DescriptionBox>
					<li>회원 (명예회원 제외)의 회비</li> <li>입회비, 특별회비</li> <li>찬조금품</li>
					<li>보조금 및 기부금</li>
					<li>후원금 및 기타 수입</li>
					<li>자산에서 생기는 과실금</li>
				</S.DescriptionBox>
			</S.RuleContentItem>
			<S.RuleContentItem>
				<S.RuleSubTitle>제 19조 (회계 연도)</S.RuleSubTitle>
				<S.RuleDescription>본회의 회계연도는 매년 1월 1일부터 12월 31일까지로 한다.</S.RuleDescription>
			</S.RuleContentItem>
			<S.RuleContentItem>
				<S.RuleSubTitle>제 20조 (시행일)</S.RuleSubTitle>
				<div>
					<S.RuleDescription style={{ color: '#DC2626' }}>이 회칙은 1990년 8월 24일 부터 시행한다.</S.RuleDescription>
					<S.RuleDescription style={{ color: '#DC2626' }}>이 회칙은 2016년 11월 25일부터 시행한다.</S.RuleDescription>
					<S.RuleDescription style={{ color: '#DC2626' }}>이 회칙은 2025년 3월 12일부터 시행한다.</S.RuleDescription>
				</div>
			</S.RuleContentItem>
		</S.RuleContent>
	</S.RuleContainer>
);
export default Rules;
